import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/offline/merchant/comment/list', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/offline/merchant/comment/detail', Object.assign({}, options, { params }))

export const remove = (params, options) =>
request.post('/api/v4ward/offline/merchant/comment/remove', qs.stringify(params),options);

export const add = (params, options) =>
request.post('/api/v4ward/offline/merchant/comment/submit', params,options)

export const update = (params, options) =>
request.post('/api/v4ward/offline/merchant/comment/submit', params,options)
